import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Caption, CaptionImage, CaptionFooter } from '../Caption';
import ProductionCaptionHeader from './ProductionCardHeader';
import SaleOrRent from '../SaleOrRent';
import Ago from '../Ago';
import IsGuest from '../../utils/IsGuest';
import { FREE_PLAN } from '../../constants';
import { IsArtist } from '../../utils/Roles';

class ProductionCard extends React.PureComponent {
  render() {
    const { production, animate } = this.props;
    const image = production.images.length > 0 ? production.images[0].url : '';
    const isFree = production.owner.plan === FREE_PLAN;

    return (
      <Caption horizontal={isFree} animate={animate}>
        <CaptionImage
          url={image}
        />

        <div className={`caption detail ${isFree && 'horizontal'}`}>
          <ProductionCaptionHeader
            id={production.id}
            slug={production.slug}
            year={production.year}
            gender={production.type}
            saleOrRent={production.saleOrRent}
            name={production.name}
            theater={(IsGuest() || IsArtist()) ? '' : production.owner}
            hideInfo={this.props.hideInfo}
            isFree={isFree}
            isDigital={production.isDigital}
          />

          {!isFree && !production.isDigital && (
            <Fragment>
              <div className="sale-rent-list">
                <SaleOrRent className="pb-10" name="Escenografía/Sets" value={production.sets} />
                <SaleOrRent className="pb-10" name="Vestuario/Costumes" value={production.costumes} />
                <SaleOrRent className="pb-10" name="Sobretítulos/Titles" value={production.titles} />
                <SaleOrRent className="pb-10" name="Utilería/Props" value={production.props} />
                <SaleOrRent className="pb-10" name="Orquestación/Orchestration" value={production.orchestration} />
              </div>

              {/* <CaptionFooter>
                <div>
                  <Ago time={production.createdAt} />
                  <div className="clearfix" />
                </div>
              </CaptionFooter> */}
            </Fragment>
          )}
        </div>
      </Caption>
    );
  }
}

ProductionCard.propTypes = {
  animate: PropTypes.string,
  production: PropTypes.object,
  hideInfo: PropTypes.bool,
};

ProductionCard.defaultProps = {
  animate: '',
  production: {},
  hideInfo: false,
};

export default ProductionCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ProductionCard.js